import { Navigate, Outlet } from "react-router-dom";

import { useSession } from "@/core/state/session";
import type { Role } from "@/domain/auth";

export function RoleGate({ anyOf, allowPermissions = false }: { anyOf: Role[]; allowPermissions?: boolean }) {
  const identity = useSession((state) => state.identity);
  const roles = identity?.roles ?? [];
  if (anyOf.some((role) => roles.includes(role))) {
    return <Outlet />;
  }
  // Fine-grained operators: any catalog permission (or wildcard) may enter admin shell.
  if (allowPermissions) {
    const perms = identity?.permissions ?? [];
    if (perms.includes("*") || perms.some((p) => p.includes("."))) {
      return <Outlet />;
    }
  }
  // Developers have a separate console; keep a direct /admin visit useful.
  if (roles.includes("oidc_developer") && anyOf.includes("tenant_admin")) {
    return <Navigate to="/developer" replace />;
  }
  return <Navigate to="/" replace />;
}
